import React from 'react';

import { createEntity } from '../../technical-application/technical-application.reducer';
import { ModalCreateEntity } from '../../../shared/components/modal-create-entity';

export const ModalTechnicalApplicationCreate = () => {
  return <ModalCreateEntity createEntity={createEntity} entityKey="technicalApplication" />;
};
